import { createSlice } from "@reduxjs/toolkit";
import { reducerPaths } from "../../app/reducerPaths";
import { liveAuctionApi, useGetBidHistoryQuery } from "../liveAuction/liveAuctionApi";
import { revertAll } from "../../app/revertAll";
import { Bidding_Through } from "../../utils/constants/auction";

const initialState = {
  buyNowData: {
    data: [],
  },
  bidHistory: {
    data: []
  }
};

const buyNowSlice = createSlice({
  name: reducerPaths.buyNow,
  initialState,
  reducers: {
    setBuyNowMultipleFields: (state, action) => {
      for (let i = 0; i < Object.entries(action?.payload)?.length; i++) {
        state[Object.entries(action?.payload)?.[i]?.[0]] = Object.entries(action?.payload)?.[i]?.[1];
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(revertAll, () => initialState);
    builder.addMatcher(
      liveAuctionApi.endpoints.getBidHistory.matchFulfilled,
      (state, { payload }) => {
        if (payload) {
          state.bidHistory.data = (payload?.TopBids || [])
            ?.filter?.(bid => {
              return (bid?.Bidding_Through === Bidding_Through.BuyNow)
            })
            ?.map?.(bid => {
              return {
                ...(bid || {}),
                amount: bid?.Bid_Amount,
                dateTime: bid?.Bid_Date,
                id: bid?.Bid_Id,
                dealerId: bid?.Dealer_Id,
                deliveryMode: bid?.Delivery_Mode,
                Vehicle_Id: bid?.Vehicle_Id,
              }
            })
        }
      }
    );
  }
});

export const {
  setBuyNowMultipleFields
} = buyNowSlice.actions;

export default buyNowSlice.reducer;
